export { default as MenuTreeSolidIcon } from './MenuTreeSolidIcon';
